export default "__VITE_ASSET__DQJtOvRg__"